// extracted by mini-css-extract-plugin
module.exports = {"preview":"EmailListItem_preview__hHDbq","name":"EmailListItem_name__3lRfs"};